var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareFacebook = function SvgIconShareFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M3.527 19.167 3.5 10.834H.167V7.501H3.5V5.417C3.5 2.324 5.416.834 8.175.834c1.321 0 2.457.098 2.788.142V4.21H9.05c-1.501 0-1.792.713-1.792 1.76V7.5h4.367L9.96 10.834h-2.7v8.333z"
  })));
};
export default SvgIconShareFacebook;